export const _ADD               = "aYqo/hhZsx1K3nE/bpdyM7k+9dJey/go18zIUHBUFrE=";
export const _EDIT              = "NzWrMOTi9/PA859Lhrw/ybab/CbhxlMn0sWhd89xI0I=";
export const _VIEW              = "FoTjQrWdNWIiz1gQri0OTGRsa7Ya9DU1ZRCWLUbHMTE=";
export const _DELETE            = "7bg4bdvvNwcprD1u5ZfzrF8W5Ix8AeYE3h16U3FKQiM=";
export const _RECOVER           = "/OR6lqDn/HPcg1AFPyiKFCaTcjEeS1lCJUsxRuPU/1k=";
export const _LIST              = "4k1F8+iwP5mbxAbp8cUKKZrR+rhjms2Bhv/KyKQJ6Fc=";
export const _TRASH             = "lyRGZnrKMs5SbNYG/hCFrAk34th7RK1L/WK0psQi6Pk=";